import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f24770da")

_pushScopeId("data-v-f24770da")
const _hoisted_1 = { class: "text" }
const _hoisted_2 = { id: "faq-list" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TheFaqListItem = _resolveComponent("TheFaqListItem")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("p", _hoisted_1, "Seznam tipu a triků (" + _toDisplayString(_ctx.faqs.length) + ")", 1),
    _createVNode("ul", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.faqs, (faq) => {
        return (_openBlock(), _createBlock("li", {
          key: faq.id
        }, [
          _createVNode(_component_TheFaqListItem, {
            faq: faq,
            "is-rearranging": _ctx.isRearranging,
            "list-length": _ctx.faqs.length,
            onMoveFaq: _ctx.moveFaq,
            onRemoveFaq: _ctx.removeFaqFromList,
            onEditFaq: _ctx.editFaq,
            onInvokeError: _ctx.invokeError,
            onInvokeSuccess: _ctx.invokeSuccess
          }, null, 8, ["faq", "is-rearranging", "list-length", "onMoveFaq", "onRemoveFaq", "onEditFaq", "onInvokeError", "onInvokeSuccess"])
        ]))
      }), 128))
    ])
  ], 64))
})